import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import Empty from '../../components/empty/empty';
import ErrorComponent from '../../components/error/error';
import FeatureTitle from '../../components/feature-title/feature-title';
import List from '../../components/list/list';
import Loading from '../../components/loading/loading';
import SubmitButton from '../../components/submit-button/submit-button';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Helpers
import { classroomsToLabel } from '../../helpers/announcement-helper';

// Services
import EventService from '../../services/event-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';

const EventList = () => {
  const titles: ListContentTitle[] = [
    { text: 'Título' },
    { text: 'Turmas' },
    { text: 'Data de envio', align: 'right' },
    { text: 'Data do evento', align: 'right' },
    { text: 'Visualizados', align: 'right' },
    { text: 'Aceitos', align: 'right' },
    { text: 'Recusados', align: 'right' },
  ];

  const [error, setError] = useState(false);
  const [eventList, setEventList] = useState<ListContent[]>(null);
  useEffect(() => {
    const schoolService = new SchoolService();
    const storageService = new StorageService();
    const schoolId = storageService.getEmployee().schoolId;

    schoolService
      .getSchoolById(schoolId)
      .then((school) => new EventService(school.uuid).listAllBackoffice())
      .then((items) => {
        const newEventList: ListContent[] = items.map((item) => ({
          linkTo: `/eventos/${item.id}`,
          data: [
            {
              text: item.title,
              customStyle: { maxWidth: '250px' },
            },
            {
              text: classroomsToLabel(item.classrooms),
            },
            {
              text: format(parseISO((item.scheduledAt ?? item.createdAt).local), 'dd/MM/yyyy'),
              subText: item.isScheduled ? 'Agendada' : null,
              align: 'right',
            },
            {
              text: format(parseISO(item.startsAt.local), 'dd/MM/yyyy'),
              align: 'right',
            },
            {
              text: `${item.seenRecipients}/${item.totalRecipients}`,
              align: 'right',
            },
            {
              text: `${item.acceptedRecipients}/${item.totalRecipients}`,
              align: 'right',
            },
            {
              text: `${item.declinedRecipients}/${item.totalRecipients}`,
              align: 'right',
            },
          ],
        }));

        setEventList(newEventList);
      })
      .catch(() => setError(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <ErrorComponent type='contentFull' />;

  if (!eventList) return <Loading type='contentFull' />;

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.singleWithActionButtons}
      actionButtonPosition={BaseContentContainerActionButtonPosition.top}
    >
      <ButtonsBar pattern='firstSeparate'>
        <FeatureTitle title='eventos' />
        <Link to='/eventos/criar'>
          <SubmitButton value='criar novo evento' variant='primary' />
        </Link>
      </ButtonsBar>

      {eventList.length > 0 ? (
        <List titles={titles} contents={eventList} />
      ) : (
        <Empty />
      )}
    </BaseContentContainer>
  );
};

export default EventList;
